import { render } from "./MatchTypeFilterBody.vue?vue&type=template&id=8c4b0306"
import script from "./MatchTypeFilterBody.vue?vue&type=script&lang=js"
export * from "./MatchTypeFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__